export enum FecAccountMappingSortKey {
  AccountNo = 'accountNo',
  Status = 'status',
}
